import { Card, Row } from 'antd';
import React from 'react'
import Heading from '../../../../component/common/Heading';
import CRUDComponent from '../../../../component/common/CRUD-Component';
import CONSTANTS from '../../../../util/constant/CONSTANTS';
import { PERMISSION } from '../../../../util/functions';
import { testimonialExportData } from '../../../../util/exportData';

const Testimonials = ({ accessPermission }) => {
    return (
        <>
            <div>
                <Card className="my-5">
                    <Heading>Testimonials</Heading>
                    <Row>
                        <CRUDComponent
                            title='Testimonials'
                            exportData={testimonialExportData}
                            accessPermission={accessPermission}
                            GET={{
                                API: CONSTANTS.API.setting.testimonial.getAll,
                                DataModifier: (res, API, Setrefresh) => {
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `T${data?.id.toString().padStart(7, "0")}`,
                                            rating: {
                                                ratings: data?.starRating ?? 0
                                            },
                                            ratingD: data?.starRating ?? 0,
                                            isBlockedD: data?.isBlocked ? 'Yes' : 'No',
                                            block: {
                                                checked: !data?.isBlocked,
                                                id: data?.id,
                                                isDisable: PERMISSION[accessPermission] === 'READ',
                                                onClick: (id, val) => {
                                                    const UpdateAPIEnd = { ...CONSTANTS?.API.setting.testimonial.update };
                                                    UpdateAPIEnd.endpoint = `${UpdateAPIEnd?.endpoint}${id}`;
                                                    API.sendRequest(
                                                        UpdateAPIEnd,
                                                        () => {
                                                            Setrefresh((prev) => !prev);
                                                        },
                                                        { isBlocked: val },
                                                        `Testimonial ${val ? "Blocked" : "Unblock"} Successfully`
                                                    );
                                                },

                                            },


                                        }
                                    });
                                },
                                column: CONSTANTS.TABLE.TESTIMONIALS,
                            }}
                            isSearch
                            UPDATE={{
                                API: CONSTANTS.API.setting.testimonial.update,
                                isFormData: true,
                                message: "Edit Testimonial successfully",
                                modaltitle: "Edit Testimonial",
                                modalFields: CONSTANTS.FORM_FIELD.EDIT_TESTIMONIAL_MODAL,
                                // payloadModifier: (res) => res,
                            }}
                            CREATE={{
                                API: CONSTANTS.API.setting.testimonial.add,
                                isFormData: true,
                                message: "Created Testimonial successfully",
                                modaltitle: "Add Testimonial",
                                modalFields: CONSTANTS.FORM_FIELD.TESTIMONIAL_MODAL,
                                // payloadModifier: (res) => res,
                            }}
                            DELETE={{
                                API: CONSTANTS.API.setting.testimonial.delete,
                                message: "Deleted Testimonial Successfully",
                            }}
                        />
                    </Row>
                </Card>

            </div>
        </>
    )
}

export default Testimonials